/** Escape one CSV cell (quotes doubled, always quoted). */
export const csvCell = (value) =>
  `"${String(value ?? "").replace(/"/g, '""')}"`;

/**
 * Build a CSV string from a header row and data rows.
 * Prefixed with a BOM so Excel opens accented names (ñ) correctly.
 */
export const toCsv = (header, rows) =>
  "﻿" + [header, ...rows].map((r) => r.map(csvCell).join(",")).join("\r\n");

/** Trigger a browser download for a text file. */
export const downloadTextFile = (
  content,
  fileName,
  type = "text/csv;charset=utf-8;",
) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
